import cn from 'classnames';
import moment from 'moment-timezone';
import { useIntl } from 'react-intl';

import { FlightsSummaryStyled } from './FlightsSummary.styles';

import type { Moment } from 'moment-timezone';

type Props = {
  className?: string;
  dates: Moment[];
  subTitle?: string;
  title?: string;
  total: string;
};

export function FlightsSummary({ className, dates, subTitle, title, total }: Props) {
  const { formatMessage } = useIntl();

  const minDate = dates.length ? moment.min(dates).format('MMM DD, YYYY') : '-';
  const maxDate = dates.length ? moment.max(dates).format('MMM DD, YYYY') : '-';

  return (
    <FlightsSummaryStyled className={cn('flightsSummary', className)}>
      <div className="flightsSummary__titleContainer">
        {title && <div className="flightsSummary__titleContainerTitle">{title}</div>}
        <div className="flightsSummary__titleContainerSubtitle">{subTitle}</div>
      </div>
      <div className="flightsSummary__dataContainer">
        <div className="flightsSummary__dataContainerDate">{minDate}</div>
        <div>
          {formatMessage({
            defaultMessage: 'to',
            id: 'spc.flightSettings.summary.dateTo'
          })}
        </div>
        <div className="flightsSummary__dataContainerDate">{maxDate}</div>
        <div className="flightsSummary__dataContainerSeparator" />
        <div className="flightsSummary__dataContainerTotal">{total}</div>
      </div>
    </FlightsSummaryStyled>
  );
}
